module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumbs"
  }, _vm._l((_vm.crumbs), function(crumb, index) {
    return _c('li', {
      staticClass: "breadcrumbs__crumb"
    }, [(index == 0) ? _c('svg-icon', {
      staticClass: "breadcrumbs__home-icon",
      attrs: {
        "icon": _vm.homeOutline,
        "width": 16,
        "height": 16
      },
      nativeOn: {
        "click": function($event) {
          return _vm.crumbClickHandler(crumb, index)
        }
      }
    }) : _c('span', {
      staticClass: "breadcrumbs__name",
      on: {
        "click": function($event) {
          return _vm.crumbClickHandler(crumb, index)
        }
      }
    }, [_vm._v(_vm._s(crumb.name))]), _vm._v(" "), (_vm.hasSeparator(index)) ? _c('svg-icon', {
      staticClass: "breadcrumbs__separator",
      attrs: {
        "icon": _vm.arrow,
        "width": 5,
        "height": 8
      }
    }) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6510c4da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/attributePanel/components/BreadCrumbs.vue
// module id = 1919
// module chunks = 0